import React from 'react';
import UserLoginButton from "../ui/userLoginButton";
import {loaderDisable, loaderEnable} from "../ui/loaderView";
import {saveQuote} from "../../api/server-api";
import {showCheckoutLayout} from "../../actions/actionFunctions";
import {getCurrentLayout} from "../appLayout";
import {showQuoteSavedNotification} from "../ui/successNotification";
import Analytics from '../../analytics';

export default class ShoppingCart extends React.Component {

  getRecentlyViewedItems = () => {
    const layout = getCurrentLayout();
    // console.log("layout.getActiveFeatures()", layout.getActiveFeatures());
    const activeFeatures = layout.getActiveFeatures()
      .filter(feature => {
        if (!feature.cartFeature || !feature.cartFeature.dbFeature
          || (feature.cartFeature.partName && feature.cartFeature.partName.includes("laceholder")) || feature.partId === "shower_body") {
          return false
        }
        if (feature.partId.includes("pony_wall") && feature.cartFeature.getParent) {
          const showerParent = feature.cartFeature.getParent().getParent().layout.parts.Shower;
          if (showerParent.showerDimensions() !== "Pony") {
            return false
          }
        }
        const featureId = feature.cartFeature.dbFeature.id;
        return !feature.partId.includes("top_cabinet_module") && this.props.cartItems.every((cartItem) => {
          return cartItem.cartFeature.dbFeature.id !== featureId
        })
      });
    const recentlyViewedItems = (Array.isArray(this.props.recentlyViewedItems) && this.props.recentlyViewedItems.length)
      ? this.props.recentlyViewedItems
        .filter(recentItem => {
          const recentItemId = recentItem.dbFeature.id;
          return activeFeatures.every(cartItem => cartItem.cartFeature.dbFeature.id !== recentItemId)
            && this.props.cartItems.every((cartItem) => cartItem.cartFeature.dbFeature.id !== recentItemId)
        })
        .map(recentItem => {
          return {
            selectionGroup: recentItem.getParent().getParent().partName,
            partId: recentItem.partId,
            quantity: 0,
            cartFeature: recentItem
          };
        })
      : [];
    return [...activeFeatures, ...recentlyViewedItems]
  };

  getFinalButton = () => {
    if (document.kvConfig.canSaveQuote !== false) { // if document.kvConfig.canSaveQuote is null it is ok, we are checking only for false
      let intlText = "";
      let onClick = () => {};
      const fabricatorSettings = this.props.fabricatorData.settings;
      if (fabricatorSettings.checkout) {
        if (fabricatorSettings.sureTax && !this.props.isPhoneNumberValidated) {
          return {
            intlText: "quotingTool.featureInfo.priceLockedTitle",
            onClick: () => this.handleCheckOut("updateTax"),
          }
        }
        onClick = this.handleCheckOut;
        intlText = (fabricatorSettings.enableDocuSign || fabricatorSettings.hasPaymentGateway || document.kvConfig.showBackToDashboard)
          ? "shoppingCart.checkoutButtonCheckoutNow"
          : !fabricatorSettings.leadCaptureOnQuote // leadCaptureOnQuote is OFF
            ? "shoppingCart.checkoutButtonBuyNow"
            : !fabricatorSettings.twoFA // leadCaptureOnQuote is ON
              ? this.props.isPhoneNumberValidated || document.kvConfig.isBackend
                ? "shoppingCart.checkoutButtonBuyNow"
                : "shoppingCart.checkoutButtonUnlockPrice"
              : this.props.userIsLoggedIn || document.kvConfig.isBackend
                ? "shoppingCart.checkoutButtonBuyNow"
                : "shoppingCart.checkoutButtonUnlockPrice"
      } else if (fabricatorSettings.leadCaptureOnQuote) {
        intlText = "shoppingCart.checkoutButtonEmailQuote";
        onClick = this.handleSaveClick;
      } else {
        intlText = "shoppingCart.checkoutButtonStartOver";
        onClick = this.handleStartOverClick;
      }
      if (this.props.fabricatorData.isLakesideSurfaces) {
        intlText = "buttons.submit"
      }
      return {
        intlText,
        onClick,
      }
    }
    return null
  };

  handleCheckOut = async (assignButtonsToShow) => {

    if (document.kvConfig.isBackend && this.props.toggleShowAssignQuotePopup && !this.props.editToken) {
      this.props.toggleShowAssignQuotePopup(true, assignButtonsToShow); // assignButtonsToShow should be "checkout" and come only from the button group
      return;
    }

    const fabricatorSettings = this.props.fabricatorData.settings;
    Analytics.sendClickEvent("checkout-buy-now-button");
    if (!UserLoginButton.handleLoginClick({...this.props, checkout: true}))
      return ;

    loaderEnable("loader.savingQuoteText");

    saveQuote({
      submit: true,
      showContractSignOnError: true
    })
      .then((response) => {
        if (response) {
          /*let responseDataBase = response;
          if (response.data) {
            responseDataBase = response.data;
          }

          const responseData = typeof responseDataBase === 'object' ? responseDataBase : JSON.parse(responseDataBase);
          console.log('saveQuote response:', responseData);*/
          loaderDisable();
        }
        showQuoteSavedNotification();
        showCheckoutLayout(fabricatorSettings);
      }).catch((error) => {
      console.log('saveQuote error:', error);
      loaderDisable();
    })
  };

}
